import BaseModel from '../core/BaseModel'
export default class RequestActivationChangeLogModel extends BaseModel {
    constructor() {
        super({ 
                name: "request_activation_changed_log",
                tableName: 'core_request_activation_changed_log'
            }, 
            {
            id: { 
                name: 'id', 
                type: "String", 
                label: 'ID', 
                primaryKey: true,
                display: false
            },
            modified_date: { 
                name: 'modified_date', 
                type: "CustomDateTime", 
                label: 'Thời gian cập nhật',
                class: 'center',
                width: 13
            },
            full_name: { 
                name: 'full_name', 
                type: "String", 
                label: 'Người cập nhật',
                class: 'center',
                width: 20,
                computed: (data) => {
                    data.full_name = (data.users !== undefined && data.users !== null) ? data.users.full_name  :  '';
                }
            },
            organization: { 
                name: 'organization', 
                label: 'Đơn vị cập nhật',
                class: 'center',
                type: "String",
                width: 20,
                computed: (data) => {
                    data.organization = (data.organizations !== undefined && data.organizations !== null) ? data.organizations.name  :  '';
                }
            },
            content: { 
                name: 'content', 
                label: 'Nội dung cập nhật',
                class: 'center',
                computed: (data) => {
                    data.content = data.message;
                }
            },
            modifier_id: {
                refs: 'users { full_name } organizations { name }  message modified_date ',
                display: false
            }
        },)
    }

}